import { Box, Heading } from 'grommet';
import { useMemo } from 'preact/hooks';

import { onLinkButtonClick } from '../helpers';
import HabitatInfoCardMobile from './HabitatInfoCardMobile';
import style from './style.scss';

const MobileMap = ({ habitats, urlParams, showTrailers, onShowTrailer }) => {
  const onlineHabitats = useMemo(
    () =>
      habitats
        .filter((habitat) => habitat.isStreamOn && !habitat.liveTalk)
        .sort((first, second) => (second.isFreemium ?? false) - (first.isFreemium ?? false)),
    [habitats],
  );

  const liveTalkHabitats = useMemo(
    () =>
      habitats
        .filter((habitat) => habitat.liveTalk)
        .sort((first, second) => (second.isFreemium ?? false) - (first.isFreemium ?? false)),
    [habitats],
  );

  const offlineHabitats = useMemo(() => habitats.filter((habitat) => !habitat.liveTalk && !habitat.isStreamOn), [habitats]);

  return (
    <div className={style.mobileMap}>
      {liveTalkHabitats.length > 0 && (
        <Box height={{ min: 'fit-content' }}>
          <Heading level="3">Live Talks</Heading>
          <Box height={{ min: 'fit-content' }}>
            {liveTalkHabitats.map((habitat) => (
              <HabitatInfoCardMobile
                key={habitat._id}
                online
                liveTalk
                image={habitat.profileImage}
                zooName={habitat.zoo.name}
                zooLogo={habitat.zoo.logo}
                title={habitat.animal}
                description={habitat.description}
                buttonText="Visit"
                free={urlParams.freeHabitat === habitat._id}
                onClick={onLinkButtonClick(urlParams, habitat)}
                label={habitat.label}
                trailer={showTrailers && habitat.trailer}
                onShowTrailer={onShowTrailer}
              />
            ))}
          </Box>
        </Box>
      )}
      {onlineHabitats.length > 0 && (
        <Box height={{ min: 'fit-content' }}>
          {offlineHabitats.length > 0 && <Heading level="3">Online</Heading>}
          <Box flexGrow="1" height={{ min: 'fit-content' }}>
            {onlineHabitats.map((habitat) => (
              <HabitatInfoCardMobile
                key={habitat._id}
                online
                image={habitat.profileImage}
                zooName={habitat.zoo.name}
                zooLogo={habitat.zoo.logo}
                title={habitat.animal}
                description={habitat.description}
                buttonText="Visit"
                free={urlParams.freeHabitat === habitat._id}
                onClick={onLinkButtonClick(urlParams, habitat)}
                label={habitat.label}
                trailer={showTrailers && habitat.trailer}
                onShowTrailer={onShowTrailer}
              />
            ))}
          </Box>
        </Box>
      )}
      {offlineHabitats.length > 0 && (
        <Box height={{ min: 'fit-content' }}>
          <Heading level="3">Offline</Heading>
          <Box height={{ min: 'fit-content' }}>
            {offlineHabitats.map((habitat) => (
              <HabitatInfoCardMobile
                key={habitat._id}
                online={false}
                image={habitat.profileImage}
                zooName={habitat.zoo.name}
                zooLogo={habitat.zoo.logo}
                title={habitat.animal}
                description={habitat.description}
                buttonText="Visit"
                free={urlParams.freeHabitat === habitat._id}
                onClick={onLinkButtonClick(urlParams, habitat)}
                label={habitat.label}
                trailer={showTrailers && habitat.trailer}
                onShowTrailer={onShowTrailer}
              />
            ))}
          </Box>
        </Box>
      )}
    </div>
  );
};
export default MobileMap;
